module.exports = __webpack_public_path__ + "static/media/irishdefence.47f6983b.png";